import React, {Component,Fragment} from 'react';
import './sample.css';

export class LeadManagement extends Component{
    render(){
        return(
          <Fragment>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/lead1.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/lead1.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Lead Creation </span><br /><span>with configurable fields</span>​</p>
          </div>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/lead2.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/lead2.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Lead details view</span><br /><span>with call and update action​</span></p>
          </div>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/lead3.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/lead3.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Sales funnel</span><br /><span>in summary view</span>​​</p>
          </div>
        </Fragment>
    )
    }
}
export class TaskManagement extends Component{
    render(){
        return(
          <Fragment>
            <div className="slider-item">
              <div className="sample-element-image">
                <img src={require('../../images/sample/task1.png')} alt="usecase" className="image1 img-fluid"/>
                <img src={require('../../images/sample/task1.png')} alt="usecase" className="image2 img-fluid" />
              </div>
              <p><span>Create task quickly</span><br /><span>with notifications and reminders</span></p>
            </div>
            <div className="slider-item">
              <div className="sample-element-image">
                <img src={require('../../images/sample/task2.png')} alt="usecase" className="image1 img-fluid"/>
                <img src={require('../../images/sample/task2.png')} alt="usecase" className="image2 img-fluid" />
              </div>
              <p><span>Task summary view</span><br /><span>with all key details at a glance</span></p>
            </div>
            <div className="slider-item">
              <div className="sample-element-image">
                <img src={require('../../images/sample/task3.png')} alt="usecase" className="image1 img-fluid"/>
                <img src={require('../../images/sample/task3.png')} alt="usecase" className="image2 img-fluid" />
              </div>
              <p><span>Prompt completion </span><br /><span>with poke, call and notifications</span></p>
            </div>
          </Fragment>
    )
    }
}

export class ExpenseReporting extends Component{
    render(){
        return(
          <Fragment>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/expense1.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/expense1.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Add expenses</span><br /><span>on the move</span></p>
          </div>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/expense2.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/expense2.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Auto bill submission</span><br /><span>using APIs and email for processing</span>​</p>
          </div>
          <div className="slider-item">
            <div className="sample-element-image">
              <img src={require('../../images/sample/expense3.png')} alt="usecase" className="image1 img-fluid"/>
              <img src={require('../../images/sample/expense3.png')} alt="usecase" className="image2 img-fluid" />
            </div>
            <p><span>Add bill copy</span><br /><span>for easy reimbursement</span></p>
          </div>
        </Fragment>
    )
    }
}


// WEBPACK FOOTER //
// ./src/components/Sample/File.js